import { render, staticRenderFns } from "./SendNews.vue?vue&type=template&id=b35d6534&scoped=true"
import script from "./SendNews.vue?vue&type=script&lang=js"
export * from "./SendNews.vue?vue&type=script&lang=js"
import style0 from "./SendNews.vue?vue&type=style&index=0&id=b35d6534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35d6534",
  null
  
)

export default component.exports